import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { CoreContact } from '../../../models/core-contact/core-contact.model';
import { CoreContactSerializer } from '../../../models/core-contact/core-contact.serializer.class';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";


@Injectable()
export class CoreContactService extends BaseApiService<CoreContact> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient, 
            null, 
            "corecontactfields",
            new CoreContactSerializer(), 
            new CustomErrorHandlerService()
        );
    }

    searchForPages(businessUnit: string): Observable<CoreContact[]> {
        return this.httpClient
            .get(`${this.url}/corecontactfields/search/forpages`, {
                params: { businessUnit }
            })
            .pipe(map((data: any) => data));
    }
}